export { default } from './isImmutable'
